<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<p class="h2f"><span class="right_1" epub:type="pagebreak" id="page_vi" title="vi"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii">CONTENTS</span></span></p>
<p class="tocf01" id="ack"><a href="#/text/00a_fm0f"><i>Acknowledgments</i></a></p>
<p class="tocf0" id="list"><a href="#/text/00a_fm0g"><i>List of Abbreviations</i></a></p>
<p class="tocf" id="int"><a href="#/text/00b_intro">Introduction</a></p>
<p class="tocc" id="ent1"><a href="#/text/01_entracte01">Entr’Acte 1: <i>The Michigan Film Review</i></a></p>
<p class="tocc1" id="ch1"><a href="#/text/02_ch01">1<span class="space1">Mapping Circulation in Detroit’s Movie Market</span></a></p>
<p class="tocc" id="ent2"><span href="#/text/03_entracte02" title="Link target outside of Sample">Entr’Acte 2: Detroit Area Picture Theaters</span></p>
<p class="tocc" id="ent3"><span href="#/text/04_entracte03" title="Link target outside of Sample">Entr’Acte 3: John H. Kunsky and George W. Trendle</span></p>
<p class="tocc1" id="ch2"><span href="#/text/05_ch02" title="Link target outside of Sample">2<span class="space1">Movies, Live Acts, and the Theatrical Experience: Programming Practices in the Motor City</span></span></p>
<p class="tocc" id="ent4"><span href="#/text/06_entracte04" title="Link target outside of Sample">Entr’Acte 4: Detroit-Made Films</span></p>
<p class="tocc" id="ent5"><span href="#/text/07_entracte05" title="Link target outside of Sample">Entr’Acte 5: The Metropolitan Film Company</span></p>
<p class="tocc1" id="ch3"><span href="#/text/08_ch03" title="Link target outside of Sample">3<span class="space1">“Detroit-Made” Newsreels and Other Short Nonfiction Films</span></span></p>
<p class="tocc" id="ent6"><span href="#/text/09_entracte06" title="Link target outside of Sample">Entr’Acte 6: Star Gazing</span></p>
<p class="tocc1" id="ch4"><span href="#/text/10_ch04_final" title="Link target outside of Sample">4<span class="space1">Motor City Menus for Movie Fans</span></span></p>
<p class="tocf1" id="aft"><span href="#/text/11_afterword" title="Link target outside of Sample">Afterword</span></p>
<p class="tocf0" id="bib"><span href="#/text/12_bibliography" title="Link target outside of Sample"><i>Bibliography</i></span></p>
<p class="tocf2" id="ind"><span href="#/text/13_Index" title="Link target outside of Sample"><i>Index</i></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 00a_fm0e.vue?709cd03d